<script setup lang="ts"></script>

<template>
    <p class="paragraph-sm text-foreground-alt group-aria-invalid:text-red-600">
        <slot></slot>
    </p>
</template>
